<p-toast key="risk-config-detail" position="top-right"></p-toast>
<p-confirmDialog key="risk-config-detail" styleClass="risk-config-confirm"></p-confirmDialog>

<!-- Activar o volver a una versión: siempre con motivo, que queda en el registro de activaciones. -->
<p-dialog
  [(visible)]="activateVisible"
  [modal]="true"
  [closable]="!saving"
  [header]="version?.status === 'archived' ? 'Volver a la versión ' + version?.version : 'Activar la versión ' + version?.version"
  styleClass="risk-config-activate"
  [style]="{ width: '520px' }"
>
  <p class="dialog-text">
    Desde este momento la calculadora califica con esta versión. Los arrendamientos ya sellados conservan la que tenían.
  </p>
  <label class="field">
    <span class="field-label">Motivo (mínimo {{ reasonMin }} caracteres)</span>
    <textarea pInputTextarea rows="3" [(ngModel)]="activateReason" [disabled]="saving" data-test="config-activate-reason"></textarea>
  </label>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="p-button-outlined" label="Cancelar" [disabled]="saving" (click)="activateVisible = false"></button>
    <button
      pButton
      type="button"
      icon="pi pi-check"
      [label]="version?.status === 'archived' ? 'Volver a esta versión' : 'Activar'"
      [disabled]="saving || activateReason.trim().length < reasonMin"
      (click)="activate()"
      data-test="config-activate-confirm"
    ></button>
  </ng-template>
</p-dialog>

<!-- Simulador (E4): solo lee; compara contra la activa sobre las fotos más recientes. -->
<p-dialog
  [(visible)]="simulateVisible"
  [modal]="true"
  [closable]="true"
  [maximizable]="true"
  [header]="'Simular ' + simulationLabel + ' contra la versión activa'"
  styleClass="risk-config-simulation"
  [style]="{ width: '960px' }"
>
  <p class="dialog-text" *ngIf="population === 'clients'">
    Corre las dos versiones sobre los análisis de Syntage más recientes, uno por cliente, como en la ficha del cliente. No guarda nada ni
    cambia lo que ya calculó la calculadora.
  </p>
  <p class="dialog-text" *ngIf="population === 'new_clients'" data-test="sim-new-clients-text">
    Corre las dos versiones sobre los clientes nuevos con preoferta decidida, con su calculadora de hoy, como decide la preoferta. Dice
    cuántas habrían salido, irían con Legal o quedarían en revisión. No guarda nada.
  </p>
  <div class="simulation-population" role="group" aria-label="Simular sobre">
    <button
      *ngFor="let option of populations"
      pButton
      type="button"
      class="p-button-sm"
      [class.p-button-outlined]="option.value !== population"
      [attr.aria-pressed]="option.value === population"
      [label]="option.label"
      [disabled]="simulating"
      (click)="setPopulation(option.value)"
      [attr.data-test]="'sim-population-' + option.value"
    ></button>
  </div>
  <div class="simulation-controls">
    <label class="field">
      <span class="field-label"
        >{{ population === 'clients' ? 'Clientes' : 'Arrendamientos' }} ({{ sampleLimits.min }} a {{ sampleLimits.max }})</span
      >
      <input
        pInputText
        type="number"
        [min]="sampleLimits.min"
        [max]="sampleLimits.max"
        [(ngModel)]="sampleSize"
        [disabled]="simulating"
        data-test="sim-sample-size"
      />
    </label>
    <button
      pButton
      type="button"
      class="p-button-outlined"
      icon="pi pi-refresh"
      label="Simular de nuevo"
      [loading]="simulating"
      [disabled]="simulating"
      (click)="runSimulation()"
      data-test="sim-run"
    ></button>
  </div>
  <div class="empty-state" *ngIf="simulating && !simulation" data-test="sim-loading">
    <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
    <span>Calculando las dos versiones…</span>
  </div>
  <div class="errors-box" *ngIf="simulationError" role="alert" data-test="sim-error">
    <strong>{{ simulationError }}</strong>
    <ul *ngIf="serverErrors.length">
      <li *ngFor="let error of serverErrors">{{ error }}</li>
    </ul>
  </div>
  <app-scorecard-simulation
    *ngIf="simulation && !simulationError"
    [simulation]="simulation"
    [candidateLabel]="simulationLabel"
    [canOpenClient]="canOpenClient"
    [class.is-stale]="simulating"
  ></app-scorecard-simulation>
</p-dialog>

<p-card styleClass="risk-config-card">
  <div class="page-header">
    <div class="header-left">
      <a
        pButton
        class="p-button-text p-button-sm"
        icon="pi pi-arrow-left"
        routerLink="/risk-scorecard-config"
        aria-label="Volver a las versiones"
      ></a>
      <div>
        <h1 data-test="config-title">{{ version ? 'v' + version.version + ' · ' + version.name : 'Nueva versión' }}</h1>
        <p class="header-subtitle">
          <ng-container *ngIf="derivedFromVersion">Derivada de v{{ derivedFromVersion }}. </ng-container>
          <ng-container *ngIf="version">Creada por {{ personName(version.createdBy) }} el {{ version.createdAt | mxDate }}.</ng-container>
          <ng-container *ngIf="!version">Se guarda como borrador; la calculadora no la usa hasta que se active.</ng-container>
        </p>
      </div>
    </div>
    <div class="header-right">
      <p-tag
        *ngIf="version"
        [severity]="statusUi[version.status].severity"
        [value]="statusUi[version.status].label"
        data-test="config-status"
      ></p-tag>
      <span class="dirty" *ngIf="editable && dirty" data-test="config-dirty">Cambios sin guardar</span>
      <button
        *ngIf="version && canCreate && !outdated"
        pButton
        type="button"
        class="p-button-outlined p-button-sm"
        icon="pi pi-copy"
        label="Duplicar"
        (click)="duplicate()"
        data-test="config-duplicate"
      ></button>
      <button
        *ngIf="version && canDelete && version.status === 'draft' && !version.isSystemDefault"
        pButton
        type="button"
        class="p-button-outlined p-button-danger p-button-sm"
        icon="pi pi-trash"
        label="Borrar"
        (click)="remove()"
        data-test="config-remove"
      ></button>
      <button
        *ngIf="version && canActivate && version.status !== 'active' && !outdated"
        pButton
        type="button"
        class="p-button-sm"
        [class.p-button-outlined]="dirty"
        icon="pi pi-power-off"
        [label]="version.status === 'archived' ? 'Volver a esta versión' : 'Activar'"
        [disabled]="dirty || saving"
        [pTooltip]="dirty ? 'Guarda los cambios antes de activar' : ''"
        (click)="openActivate()"
        data-test="config-activate"
      ></button>
      <button
        *ngIf="canSimulate && params && !outdated"
        pButton
        type="button"
        class="p-button-outlined p-button-sm"
        icon="pi pi-chart-bar"
        label="Simular"
        [pTooltip]="dirty ? 'Simula lo que está en pantalla, sin guardar' : ''"
        (click)="openSimulation()"
        data-test="config-simulate"
      ></button>
      <button
        *ngIf="editable"
        pButton
        type="button"
        class="p-button-sm"
        icon="pi pi-save"
        label="Guardar borrador"
        [disabled]="saving"
        (click)="save()"
        data-test="config-save"
      ></button>
    </div>
  </div>

  <p-divider></p-divider>

  <div class="empty-state" *ngIf="loading && !params" data-test="config-loading">
    <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
    <span>Cargando la versión…</span>
  </div>

  <div class="empty-state is-error" *ngIf="loadError" role="alert" data-test="config-error">
    <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
    <h3>No pudimos cargar la versión</h3>
    <span>{{ loadError }}</span>
    <button pButton type="button" class="p-button-outlined p-button-sm" icon="pi pi-refresh" label="Reintentar" (click)="load()"></button>
  </div>

  <ng-container *ngIf="params && !loadError">
    <p class="note is-warn" *ngIf="outdated" data-test="config-outdated">
      <i class="pi pi-history" aria-hidden="true"></i>
      Formato anterior de la calculadora (escala 0–100, motor 1): queda para consulta. Ya no se puede activar, duplicar ni simular.
    </p>
    <p class="note" *ngIf="!editable && version && !outdated" data-test="config-readonly">
      <i class="pi pi-lock" aria-hidden="true"></i>
      <ng-container *ngIf="version.status === 'draft' && !version.isSystemDefault">No tienes permiso para editar borradores.</ng-container>
      <ng-container *ngIf="version.status !== 'draft' || version.isSystemDefault"
        >Esta versión
        {{ version.status === 'active' ? 'está activa' : version.isSystemDefault ? 'es la semilla del sistema' : 'está archivada' }}: no se
        edita. Duplícala para proponer cambios.</ng-container
      >
    </p>

    <div class="errors-box" *ngIf="serverErrors.length" role="alert" data-test="config-server-errors">
      <strong>La API no aceptó la configuración:</strong>
      <ul>
        <li *ngFor="let problem of serverErrors">{{ problem }}</li>
      </ul>
    </div>

    <fieldset class="config-form" [disabled]="!editable || saving">
      <!-- Identidad de la versión -->
      <section class="block">
        <h2>Versión</h2>
        <div class="field-grid">
          <label class="field">
            <span class="field-label">Nombre</span>
            <input pInputText [(ngModel)]="name" maxlength="120" data-test="config-name" />
          </label>
          <label class="field">
            <span class="field-label">Descripción</span>
            <input pInputText [(ngModel)]="description" maxlength="1000" />
          </label>
          <label class="field full">
            <span class="field-label">Motivo del cambio (mínimo {{ reasonMin }} caracteres)</span>
            <textarea pInputTextarea rows="2" [(ngModel)]="changeReason" maxlength="1000" data-test="config-reason"></textarea>
          </label>
        </div>
      </section>

      <!-- Pilares -->
      <section class="block">
        <div class="block-head">
          <h2>Pilares</h2>
          <span class="sum" [class.is-bad]="!isHundred(pillarSum())" data-test="config-pillar-sum"
            >Suman {{ pillarSum() | number: '1.0-2' }} de 100</span
          >
        </div>
        <div class="field-grid three">
          <label class="field" *ngFor="let pillar of pillars">
            <span class="field-label">{{ pillarLabel(pillar) }} (%)</span>
            <input
              pInputText
              type="number"
              step="any"
              [ngModel]="params.pillars[pillar]"
              (ngModelChange)="setNumber(params.pillars, pillar, $event)"
            />
          </label>
        </div>
      </section>

      <!-- Métricas por pilar: las de primer nivel suman 100; dentro de un grupo, sus submétricas suman 100. -->
      <section class="block" *ngFor="let pillar of pillars" [attr.data-test]="'config-pillar-' + pillar">
        <div class="block-head">
          <h2>{{ pillarLabel(pillar) }}</h2>
          <span class="sum" [class.is-bad]="!isHundred(levelSum(topLevel(pillar)))"
            >Pesos: {{ levelSum(topLevel(pillar)) | number: '1.0-2' }} de 100</span
          >
        </div>

        <ng-container *ngFor="let key of topLevel(pillar); trackBy: trackByKey">
          <ng-container *ngTemplateOutlet="isGroup(key) ? groupRow : metricRow; context: { $implicit: key }"></ng-container>
        </ng-container>
      </section>

      <!-- Bandas, colateral y vetos -->
      <section class="block">
        <h2>Bandas</h2>
        <div class="field-grid three">
          <label class="field">
            <span class="field-label">Favorable desde (puntaje total)</span>
            <input
              pInputText
              type="number"
              step="any"
              data-test="config-band-favorable"
              [ngModel]="band(params.bands.favorableMin)"
              (ngModelChange)="setNumber(params.bands, 'favorableMin', $event)"
            />
          </label>
          <label class="field">
            <span class="field-label">Revisar desde (puntaje total)</span>
            <input
              pInputText
              type="number"
              step="any"
              [ngModel]="band(params.bands.reviewMin)"
              (ngModelChange)="setNumber(params.bands, 'reviewMin', $event)"
            />
          </label>
          <p class="hint">
            Escala del Excel: base hasta {{ params.scale?.baseMax ?? 90 }} más el colateral. Debajo de «Revisar» es Desfavorable. Favorable
            tiene que alcanzarse sin colateral (hasta {{ params.scale?.baseMax ?? 90 }}).
          </p>
        </div>
      </section>

      <section class="block">
        <h2>Colateral (cuenta para la banda)</h2>
        <div class="field-grid three">
          <label class="field">
            <span class="field-label">Máximo de colateral (0 a 20)</span>
            <input
              pInputText
              type="number"
              step="any"
              [ngModel]="params.collateral.maxBonus"
              (ngModelChange)="setNumber(params.collateral, 'maxBonus', $event)"
            />
          </label>
          <label class="field">
            <span class="field-label">2º obligado solidario (de los contactos del cliente)</span>
            <input
              pInputText
              type="number"
              step="any"
              [ngModel]="params.collateral.secondGuarantorPoints"
              (ngModelChange)="setNumber(params.collateral, 'secondGuarantorPoints', $event)"
            />
          </label>
          <label class="field">
            <span class="field-label">Garantía sólida</span>
            <input
              pInputText
              type="number"
              step="any"
              [ngModel]="params.collateral.solidGuaranteePoints"
              (ngModelChange)="setNumber(params.collateral, 'solidGuaranteePoints', $event)"
            />
          </label>
        </div>
      </section>

      <section class="block">
        <h2>Vetos</h2>
        <div class="veto-list">
          <div class="veto" *ngFor="let code of vetoKeys(); trackBy: trackByKey" data-test="config-veto">
            <label class="check">
              <input type="checkbox" [(ngModel)]="params.vetoes[code].enabled" />
              {{ catalog?.vetoes?.[code] ?? code }}
            </label>
            <select
              class="p-inputtext"
              [(ngModel)]="params.vetoes[code].band"
              [attr.aria-label]="'Banda mínima del veto ' + (catalog?.vetoes?.[code] ?? code)"
            >
              <option value="review">Mínimo Revisar</option>
              <option value="unfavorable">Desfavorable</option>
            </select>
          </div>
        </div>
      </section>

      <!-- Parámetros técnicos: rara vez cambian; plegados para que no estorben. -->
      <section class="block">
        <button
          type="button"
          class="advanced-toggle"
          (click)="advancedOpen = !advancedOpen"
          [attr.aria-expanded]="advancedOpen"
          data-test="config-advanced"
        >
          <i class="pi" [class.pi-chevron-right]="!advancedOpen" [class.pi-chevron-down]="advancedOpen" aria-hidden="true"></i>
          Avanzado
        </button>
        <div class="field-grid three" *ngIf="advancedOpen">
          <label class="field">
            <span class="field-label">Tramo neutro (sin dato)</span>
            <select class="p-inputtext" [(ngModel)]="params.neutralTier">
              <option *ngFor="let tier of [0, 10, 15, 20]" [ngValue]="tier">{{ tier }}</option>
            </select>
          </label>
          <label class="field">
            <span class="field-label">Tope de una métrica parcial</span>
            <select class="p-inputtext" [(ngModel)]="params.partialCap">
              <option *ngFor="let tier of [0, 10, 15, 20]" [ngValue]="tier">{{ tier }}</option>
            </select>
          </label>
          <label class="field">
            <span class="field-label">Factor de cobertura de una parcial (0 a 1)</span>
            <input
              pInputText
              type="number"
              step="any"
              [ngModel]="params.partialCoverageFactor"
              (ngModelChange)="setNumber(params, 'partialCoverageFactor', $event)"
            />
          </label>
          <label class="field">
            <span class="field-label">Cobertura mínima por pilar (pb)</span>
            <input
              pInputText
              type="number"
              step="1"
              [ngModel]="params.pillarMinCoverageBp"
              (ngModelChange)="setNumber(params, 'pillarMinCoverageBp', $event)"
            />
          </label>
          <label class="field">
            <span class="field-label">Servicio de deuda: factor de revolventes</span>
            <input
              pInputText
              type="number"
              step="any"
              [ngModel]="params.debtService.revolvingFactor"
              (ngModelChange)="setNumber(params.debtService, 'revolvingFactor', $event)"
            />
          </label>
          <label class="field">
            <span class="field-label">Servicio de deuda: tope por cuenta</span>
            <input
              pInputText
              type="number"
              step="any"
              [ngModel]="params.debtService.perAccountCap"
              (ngModelChange)="setNumber(params.debtService, 'perAccountCap', $event)"
            />
          </label>
          <label class="field">
            <span class="field-label">Depreciación: tope sobre activo fijo bruto</span>
            <input
              pInputText
              type="number"
              step="any"
              [ngModel]="params.depreciation.maxShareOfAvgGrossFixed"
              (ngModelChange)="setNumber(params.depreciation, 'maxShareOfAvgGrossFixed', $event)"
            />
          </label>
          <label class="field">
            <span class="field-label">Ejercicio incompleto: mínimo del CFDI</span>
            <input
              pInputText
              type="number"
              step="any"
              [ngModel]="params.incompleteYear.minShareOfCfdi"
              (ngModelChange)="setNumber(params.incompleteYear, 'minShareOfCfdi', $event)"
            />
          </label>
          <label class="field">
            <span class="field-label">Series: proporción mínima de la mediana</span>
            <input
              pInputText
              type="number"
              step="any"
              [ngModel]="params.seriesTrim.minShareOfMedian"
              (ngModelChange)="setNumber(params.seriesTrim, 'minShareOfMedian', $event)"
            />
          </label>
          <label class="field">
            <span class="field-label">Series: meses a recortar (0 a 12)</span>
            <input
              pInputText
              type="number"
              step="1"
              [ngModel]="params.seriesTrim.maxMonths"
              (ngModelChange)="setNumber(params.seriesTrim, 'maxMonths', $event)"
            />
          </label>
          <label class="field">
            <span class="field-label">Historial: días de reuso de una consulta</span>
            <input
              pInputText
              type="number"
              step="1"
              [ngModel]="params.creditHistory.reuseDays"
              (ngModelChange)="setNumber(params.creditHistory, 'reuseDays', $event)"
            />
          </label>
          <label class="field">
            <span class="field-label">Historial: días que cuenta como real</span>
            <input
              pInputText
              type="number"
              step="1"
              [ngModel]="params.creditHistory.realMaxAgeDays"
              (ngModelChange)="setNumber(params.creditHistory, 'realMaxAgeDays', $event)"
            />
          </label>
          <label class="field full">
            <span class="field-label">Claves de observación graves del historial (separadas por coma)</span>
            <input pInputText [ngModel]="severeKeysText()" (ngModelChange)="setSevereKeys($event)" />
          </label>
        </div>
      </section>
    </fieldset>

    <!-- Qué cambió y quién la activó -->
    <section class="block" *ngIf="version?.diff?.length" data-test="config-diff">
      <h2>Cambios contra v{{ version?.derivedFromVersion }}</h2>
      <ul class="plain-list">
        <li *ngFor="let change of version?.diff; let index = index">{{ diffText(index) }}</li>
      </ul>
    </section>

    <section class="block" *ngIf="version?.activations?.length" data-test="config-activations">
      <h2>Activaciones</h2>
      <ul class="plain-list">
        <li *ngFor="let activation of version?.activations">
          {{ activation.activatedAt | mxDate: 'datetime' }} · {{ activation.activatedBy?.name ?? 'Sistema' }}
          <ng-container *ngIf="activation.previousVersion">(reemplazó a v{{ activation.previousVersion }})</ng-container>
          <ng-container *ngIf="activation.reason"> · «{{ activation.reason }}»</ng-container>
        </li>
      </ul>
    </section>
  </ng-container>
</p-card>

<!-- Un renglón de métrica: peso y, si la usa, sus umbrales; una regla muestra qué compara. -->
<ng-template #metricRow let-key>
  <div class="metric" [attr.data-test]="'config-metric-' + key">
    <div class="metric-head">
      <span class="metric-name">{{ label(key) }}</span>
      <label class="weight">
        <span class="p-hidden-accessible">Peso de {{ label(key) }}</span>
        <input pInputText type="number" step="any" [ngModel]="params!.metrics[key].weight" (ngModelChange)="setWeight(key, $event)" />
        <span>%</span>
      </label>
    </div>
    <p class="hint" *ngIf="ruleText(key) as rule">{{ rule }}</p>
    <app-scorecard-tier-editor
      *ngIf="hasTiers(params!.metrics[key])"
      [tiers]="$any(params!.metrics[key]).tiers"
      [direction]="$any(params!.metrics[key]).direction"
      [unit]="unitOf(key)"
      [label]="label(key)"
      [readonly]="!editable"
      [tierPoints]="$any(params!.metrics[key]).tierPoints"
      (tiersChange)="setTiers(key, $event)"
      (directionChange)="setDirection(key, $event)"
      (tierPointsChange)="setTierPoints(key, $event)"
    ></app-scorecard-tier-editor>
    <div class="extra" *ngFor="let name of extraKeys(key)">
      <span class="extra-name">{{ extraLabel(name) }}</span>
      <app-scorecard-tier-editor
        [tiers]="$any(params!.metrics[key]).extra[name]"
        [direction]="$any(params!.metrics[key]).direction"
        [unit]="extraUnit(name)"
        [label]="label(key) + ' · ' + extraLabel(name)"
        [readonly]="!editable"
        [showPoints]="false"
        (tiersChange)="setExtra(key, name, $event)"
        (directionChange)="setDirection(key, $event)"
      ></app-scorecard-tier-editor>
    </div>
  </div>
</ng-template>

<!-- Un grupo: su peso dentro del pilar y sus submétricas, que suman 100 entre sí. -->
<ng-template #groupRow let-key>
  <div class="group" [attr.data-test]="'config-group-' + key">
    <div class="metric-head">
      <span class="metric-name">{{ label(key) }}</span>
      <span class="sum" [class.is-bad]="!isHundred(levelSum(members(key)))"
        >Submétricas: {{ levelSum(members(key)) | number: '1.0-2' }} de 100</span
      >
      <label class="weight">
        <span class="p-hidden-accessible">Peso del grupo {{ label(key) }}</span>
        <input pInputText type="number" step="any" [ngModel]="params!.metrics[key].weight" (ngModelChange)="setWeight(key, $event)" />
        <span>%</span>
      </label>
    </div>
    <div class="group-members">
      <ng-container *ngFor="let member of members(key); trackBy: trackByKey">
        <ng-container *ngTemplateOutlet="metricRow; context: { $implicit: member }"></ng-container>
      </ng-container>
    </div>
  </div>
</ng-template>
